// in ../components/messenger/ReplyPreview.tsx
import React from 'react';
import { X } from 'lucide-react';
import { Message } from '../../hooks/useMessages';
import { Content, MessageSnippet, PreviewWrapper, SenderName, XButton } from '../../styles/messenger/messenger.style';


interface ReplyPreviewProps {
  message: Message;
  senderName: string; 
  onCancel: () => void;
}

export const ReplyPreview: React.FC<ReplyPreviewProps> = ({ message, onCancel, senderName }) => {
  return (
    <PreviewWrapper>
      <Content>
        <SenderName>Replying to {senderName}</SenderName> {/* Assuming sender object is on message */}
        <MessageSnippet>{message.content}</MessageSnippet>
      </Content>
      <button onClick={onCancel} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
        <XButton size={20} />
      </button>
    </PreviewWrapper>
  );
};